// ink-component
import React from 'react';

import Outliner, { OutlinerProps } from '../../Outliner';

export interface InkOutlinerProps extends Omit<OutlinerProps, 'variant' | 'label' | 'hideContent'> {}

/**
 * @purpose Highlights ink components
 * @staffonly true
 * @categories accessory
 */
const InkOutliner = (props: InkOutlinerProps) => <Outliner {...props} variant="ink" label="ink" />;

InkOutliner.defaultProps = {
  children: null,
  display: 'block',
  tagOut: false,
};

InkOutliner.displayName = 'InkOutliner';

export default InkOutliner;
